import { ModuleRouter } from "@/components/module-router/module-router";

export function FitRoutes() {
  return <ModuleRouter moduleId="fit" />;
}
